import React from 'react';
import WarningIcon from '@/assets/svg/warning-active-clients.svg';
import { SUBSCRIPTION_MANAGEMENT_LABELS } from '@/epics/subscriptionManagment/constants/translations/labels';

export const EditSubscriptionPlanWarningIcon: React.FC = () => <WarningIcon />;

export const EditSubscriptionPlanWarningDescription: React.FC<{
  activeClientCount: number;
}> = ({ activeClientCount }) => (
  <>
    <span>
      {
        SUBSCRIPTION_MANAGEMENT_LABELS.INFO_ACTIVE_CLIENTS_WARNING_PREFIX.polish
      }{' '}
    </span>
    <span
      className="font-medium"
      style={{ fontFamily: 'Roboto, sans-serif', fontWeight: 500 }}
    >
      {activeClientCount}
    </span>
    <span>
      {' '}
      {SUBSCRIPTION_MANAGEMENT_LABELS.INFO_ACTIVE_CLIENTS_WARNING_SUFFIX.polish}
    </span>
  </>
);
